`use strict`;

let moment = require('../../../../node_modules/moment/min/moment-with-locales');
window.moment = moment;

let locale = ``;

let languages = ["es-en", "no-en", "usa-en", "uk"];

if ('' !== window.Laravel.language) {
  locale = window.Laravel.language;

  if ($.inArray(window.Laravel.language, languages) !== -1) {
    locale = `en-gb`;
  }

  if(window.Laravel.language === `no`) {
    locale = 'nb';
  }

  if (`` !== locale) {
    require(`../../../../node_modules/moment/locale/${locale}`);
  }
}

require('pc-bootstrap4-datetimepicker');

export default class ShowDatepicker {

  selectors = {
    linked_dates: `[data-linked="1"]`
  };

  constructor(div_datepicker) {
    this.div_timepicker = div_datepicker;
    this.init();
    this.initLinks();
  }

  init () {
    $(this.div_timepicker).datetimepicker({
      format: 'DD/MM/YYYY',
      locale: '' !== locale ? locale : ``,
      icons: {
        time: "fa fa-clock",
        date: "fa fa-calendar"
      },
      allowInputToggle: true,
      useCurrent: false
    });
  }

  initLinks () {
    $(this.selectors.linked_dates).on("dp.change", (e) => {
      let elem = e.currentTarget,
        targetElement = $(elem).data('element'),
        crtElemType = $(elem).data('type');

      if (crtElemType === `start`) {
        $(targetElement).data("DateTimePicker").minDate(e.date);
        return;
      }

      $(targetElement).data("DateTimePicker").maxDate(e.date);
    });
  }
}
